// import configs from '@/src-js/configs/index'
// import { scrollToTop } from '@/src-js/utils/global'
import Image from '@/src/components/CustomImage'
import { ArrowRight } from 'lucide-react'

import React, { useMemo } from 'react'
import styles from './index.module.scss'
const strFormat = (str: string, replaceStrArr: string | string[]) => {
  if (Array.isArray(replaceStrArr)) {
    replaceStrArr.forEach((item, index) => {
      str = str.replace(`{${index}}`, item)
    })
  } else {
    str = str.replace('{0}', replaceStrArr)
  }
  return str
}
// 导入图片资源

interface Section4Props {
  totalCarriersStr: string
  isChina: boolean
  message: {
    __operation: string
    __forcast: string
    __theWorld: string
    __combination: string
    __covered: string
    __nowInclude: string
    __contactus: string
    __automized: string
    __autoIdentifies: string
    __doneRight: string
    __distribution: string
  }
}

const Section4: React.FC<Section4Props> = ({ message, totalCarriersStr, isChina }) => {
  const items = useMemo(() => {
    return [
      {
        imgSrc: `/assets/images/api/Part4_1_${isChina ? 'zh' : 'en'}.png`,
        content: [
          {
            title: message.__theWorld,
            content: message.__combination
          },
          {
            title: message.__covered,
            content: strFormat(message.__nowInclude, totalCarriersStr)
          }
        ]
      },
      {
        imgSrc: `/assets/images/api/Part4_2_${isChina ? 'zh' : 'en'}.png`,
        content: [
          {
            title: message.__automized,
            content: message.__autoIdentifies
          },
          {
            title: message.__doneRight,
            content: message.__distribution
          }
        ]
      }
    ]
  }, [isChina, message])

  return (
    <section className={styles.section4}>
      <div className={styles.container}>
        <h2>
          {message.__operation}
          <br />
          {message.__forcast}
        </h2>
        <ul className={styles.content}>
          {items.map((item, index) => {
            return (
              <li
                key={`section4-${index}`}
                className={styles.contentItem}
                style={{ flexDirection: index / 2 === 0 ? 'row' : 'row-reverse' }}
              >
                <div className={styles.boxLeft}>
                  <Image data-yqrole="img" width={667} height={593} src={item.imgSrc} alt="BG" />
                </div>
                <ul className={styles.boxRight}>
                  {item.content.map((item, i) => {
                    return (
                      <li key={`section4-${index}-${i}`} className={styles.item}>
                        <h3>{item.title}</h3>
                        <p>{item.content}</p>
                      </li>
                    )
                  })}
                  <li>
                    <button className={styles.startFree} onClick={() => window.scrollTo({ top: 0 })}>
                      {message.__contactus}
                      <ArrowRight className={styles.arrow} />
                    </button>
                  </li>
                </ul>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Section4
